import { createRoute, Outlet, redirect } from '@tanstack/react-router'

import { StaticRouteParameter } from 'config/routing'
import { ContentTabs } from 'domains/Environment'
import { Overview as InvitationOverview } from 'domains/Environment/Invitations'
import { Overview as TeamsOverview } from 'domains/Environment/Teams'
import { Overview as UserOverview } from 'domains/Environment/Users'
import { EnvironmentPermission } from 'pages/NWPlatform/Environment/EnvironmentPermission'
import { Structure } from 'pages/NWPlatform/Environment/Structure'
import { environmentRoute } from 'pages/NWPlatform/Routing'

export const environmentLayoutRoute = createRoute({
  getParentRoute: () => environmentRoute,
  id: 'environmentLayout',
  component: Structure,
})

export const permissionLayoutRoute = createRoute({
  getParentRoute: () => environmentLayoutRoute,
  id: 'permissionLayout',
  component: EnvironmentPermission,
})

export const manageAccessLayoutRoute = createRoute({
  getParentRoute: () => permissionLayoutRoute,
  id: 'manageAccessLayout',
  component: () => (
    <>
      <ContentTabs />
      <Outlet />
    </>
  ),
})

export const manageAccessRoute = createRoute({
  getParentRoute: () => manageAccessLayoutRoute,
  path: StaticRouteParameter.MANAGE_ACCESS,
  beforeLoad: ({ location }) => {
    if (
      location.pathname.endsWith(StaticRouteParameter.MANAGE_ACCESS) ||
      location.pathname.endsWith(`${StaticRouteParameter.MANAGE_ACCESS}/`)
    ) {
      throw redirect({
        replace: true,
        from: manageAccessRoute.fullPath,
        to: usersOverviewRoute.to,
      })
    }
  },
})

type UsersOverviewSearch = {
  query?: string
}

export const usersOverviewRoute = createRoute({
  getParentRoute: () => manageAccessRoute,
  path: StaticRouteParameter.USER,
  component: UserOverview,
  validateSearch: (search: Record<string, unknown>): UsersOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

type TeamsOverviewSearch = {
  query?: string
}

export const teamsOverviewRoute = createRoute({
  getParentRoute: () => manageAccessRoute,
  path: StaticRouteParameter.TEAMS,
  component: TeamsOverview,
  validateSearch: (search: Record<string, unknown>): TeamsOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

export const invitationsOverviewRoute = createRoute({
  getParentRoute: () => manageAccessRoute,
  path: StaticRouteParameter.INVITATIONS,
  component: InvitationOverview,
})
